import { render, staticRenderFns } from "./Crawlers.vue?vue&type=template&id=45f0bffc&scoped=true&"
import script from "./Crawlers.vue?vue&type=script&lang=js&"
export * from "./Crawlers.vue?vue&type=script&lang=js&"
import style0 from "./Crawlers.vue?vue&type=style&index=0&id=45f0bffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f0bffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VDataTable,VIcon,VSpacer,VStepperContent})
